import type { AdminChatTraceResponse, TraceRequest } from '../../api';
import { formatCount, formatMs } from '../../format';

function hasWarningQuality(value?: string) {
  return Boolean(value && value !== 'exact');
}

function traceDiagnostics(trace: AdminChatTraceResponse | null) {
  return Array.isArray(trace?.diagnostics) ? trace.diagnostics : [];
}

export function RequestSummary({
  request,
  trace,
}: {
  request: TraceRequest | null;
  trace: AdminChatTraceResponse | null;
}) {
  const allDiagnostics = traceDiagnostics(trace);
  const diagnostics = (request?.diagnostic_ids || []).flatMap(id => {
    const diagnostic = allDiagnostics.find(item => item.id === id);
    return diagnostic ? [diagnostic] : [];
  });
  return (
    <div className="grid gap-3 md:grid-cols-4 xl:grid-cols-8">
      <Metric
        label="Total latency"
        value={formatMs(request?.timing.total_ms)}
      />
      <Metric label="TTFT" value={formatMs(request?.timing.ttft_ms)} />
      <Metric label="LLM" value={formatMs(request?.timing.llm_ms)} />
      <Metric label="Tool" value={formatMs(request?.timing.tool_wall_ms)} />
      <Metric label="Persist" value={formatMs(request?.timing.persist_ms)} />
      <Metric label="Tokens" value={formatCount(request?.token_total)} />
      <Metric
        label="Tool cost"
        value={`${formatCount(request?.tool_cost.calls)} calls`}
        sub={`${formatCount(request?.tool_cost.errors)} errors · ${formatCount(request?.tool_cost.timeouts)} timeouts`}
      />
      <Metric
        label="Diagnostic"
        value={diagnostics[0]?.title || request?.status || '-'}
        sub={
          hasWarningQuality(request?.quality)
            ? `quality ${request?.quality}`
            : undefined
        }
      />
    </div>
  );
}

export function Metric({
  label,
  value,
  sub,
}: {
  label: string;
  value: string;
  sub?: string;
}) {
  return (
    <div className="rounded-md border p-3">
      <div className="text-xs text-muted-foreground">{label}</div>
      <div className="text-base font-semibold">{value}</div>
      {sub ? (
        <div className="mt-1 text-xs text-muted-foreground">{sub}</div>
      ) : null}
    </div>
  );
}
